import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";
import { sendAppEmail } from "@/lib/email-send.server";

const ContactSchema = z.object({
  name: z.string().trim().min(1).max(200),
  email: z.string().trim().email().max(320),
  phone: z.string().trim().max(40).optional().or(z.literal("")),
  message: z.string().trim().min(1).max(5000),
});

const INFO_EMAIL = "info@akhusbilfritid.se";

export const sendContactMessage = createServerFn({ method: "POST" })
  .inputValidator((input) => ContactSchema.parse(input))
  .handler(async ({ data }) => {
    const { supabaseAdmin } = await import("@/integrations/supabase/client.server");

    const { data: inserted, error } = await supabaseAdmin
      .from("contact_messages")
      .insert({
        name: data.name,
        email: data.email,
        phone: data.phone || null,
        message: data.message,
      })
      .select("id")
      .maybeSingle();
    if (error) {
      console.error("contact insert", error);
      throw new Error("Kunde inte skicka meddelandet. Försök igen.");
    }

    // Notis till info@akhusbilfritid.se — får aldrig fälla användarens inskick.
    try {
      await sendAppEmail(supabaseAdmin as any, "contact-notification", INFO_EMAIL, {
        templateData: {
          name: data.name,
          email: data.email,
          phone: data.phone || "",
          message: data.message,
          submittedAt: new Date().toLocaleString("sv-SE", { timeZone: "Europe/Stockholm" }),
        },
        replyTo: data.email,
        idempotencyKey: `contact-notification-${inserted?.id ?? crypto.randomUUID()}`,
      });
    } catch (e) {
      console.error("contact email dispatch error", e);
    }

    return { ok: true };
  });

